<!-- 
	OptOut
	role: User
  Display optout form for authorized users
-->

<template>
  <div class="opt-out text-white">
    <div v-if="user.loggedIn === true">
      <div class="w-full mx-auto mb-12">
        <div
          v-if="user.apiData.Profile.Year2022OptOut"
        >
          <OptOutProcessing />
        </div>
        <div v-else>
          <OptOutForm :user="user" />
        </div>
      </div>
      <!--div class="remember sm:py-32">
        <div class="text-3xl uppercase mb-6 ">
          Remember
        </div>
        <div class="text-2xl mb-6">
          <p class="poppins text-20 gold-link t600 topmargin-sm bottommargin-sm uppercase">
            You can always opt back in: <a href="https://winwinstafflottery.ca/tickets/"
                      class="t600"
                    >GET TICKETS</a>.
          </p>
          
        </div>
        <div>
          When you buy a WinWin Staff Lottery ticket, proceeds are invested
          directly back to Alberta Area Hospitals
        </div>
        <div>That means it supports your hospitals and your community!</div>
        <div class="my-6">
          Together we can make a significant difference for our health care
          facilities across the province.
        </div>
        <div class="text-3xl uppercase my-6">
          Now that's a WinWin!
        </div>
      </div>
      <CustomerServiceBanner /-->
    </div>
    <div v-else>
      NO USER
    </div>
  </div>
</template>

<script>
	import { mapGetters } from "vuex";

	import OptOutForm from "@/components/OptOutForm";
	import CustomerServiceBanner from "@/components/CustomerServiceBanner";
	import CustomButton from "@/components/CustomButton";
	import OptOutProcessing from "@/components/OptOutProcessing";

	export default {
		name: "OptOut",
		components: {
			OptOutForm,
			CustomerServiceBanner,
			CustomButton,
			OptOutProcessing,
		},
		computed: {
			...mapGetters({
				user: "user",
			}),
		}
	};
</script>

<style scoped>
	.remember {
		padding: 100px 10px;
		width: 100%;
		background: url("../assets/alberta_proceeds.png");
		background-position: center center;
		background-size: cover;
		background-repeat: no-repeat;
	}
</style>
